.smallSpinner {
  line-height: 20px;
}
